import Vue from 'vue'
import VabIcon from '../../vab-icon/lib/vab-icon.umd.min'

Vue.component('VabIcon', VabIcon)
